import React, { useEffect, useMemo, useState } from "react";
import '../../../node_modules/bootstrap/dist/css/bootstrap.min.css';
import TableContainer from '../../components/Common/TableContainer';
import * as Yup from "yup";
import { useFormik } from "formik";

import { format } from "date-fns";
import { fr } from "date-fns/locale";

//import components
import Breadcrumbs from '../../components/Common/Breadcrumb';
import DeleteModal from '../../components/Common/DeleteModal';


import AcademicYearModal from "./partials/AcademicYearModal";

import {
    getAcademicYears as onGetAcademicYears,
    addNewAcademicYear as onAddNewAcademicYear,
    updateAcademicYear as onUpdateAcademicYear,
    deleteAcademicYear as onDeleteAcademicYear,
    getTrainingTypes as onGetTrainingTypes,
} from "store/actions";

//redux
import { useSelector, useDispatch } from "react-redux";
import { createSelector } from "reselect";

import {
    Col,
    Row,
    UncontrolledTooltip,
    Modal,
    ModalHeader,
    ModalBody,
    Form,
    Input,
    FormFeedback,
    Label,
    Card,
    CardBody,
    UncontrolledDropdown,
    DropdownToggle,
    DropdownMenu,
    DropdownItem,
    Badge,
    Button,
} from "reactstrap";
import Spinners from "components/Common/Spinner";
import { ToastContainer } from "react-toastify";
import { Link } from "react-router-dom";

const AcademicYearList = () => {

    //meta title
    document.title = "Années académiques | CinzanEdu";

    const [modal, setModal] = useState(false);
    const [isEdit, setIsEdit] = useState(false);
    const [academicYear, setAcademicYear] = useState(null);
    




    const dispatch = useDispatch();

    const AcademicYearProperties = createSelector(
        (state) => state.academicYearReducer, 
        (academicYearReducer) => ({
            academicYears: academicYearReducer.academicYears,
            loading: academicYearReducer.loading
        })
    );

    const {academicYears, loading} = useSelector(AcademicYearProperties);

    const [isLoading, setLoading] = useState(loading)



    const TrainingTypeProperties = createSelector(
        (state) => state.trainingTypeReducer, 
        (trainingTypeReducer) => ({
            trainingTypes: trainingTypeReducer.trainingTypes,
        })
    );

    const {trainingTypes} = useSelector(TrainingTypeProperties);


    // Chargement des données initiales

    useEffect(() => {
        if (!academicYears.length) dispatch(onGetAcademicYears());
        if (!trainingTypes.length) dispatch(onGetTrainingTypes());
        
    }, [dispatch, academicYears.length, trainingTypes.length, loading]);


    const toggle = () => {
        if (modal) {
            setModal(false);
            setAcademicYear(null);
        } else {
            setModal(true);
        }
    };

    const handleAcademicYearClick = (academicYear) => {
        
        setAcademicYear({
            id: academicYear.id,
            uuid: academicYear.uuid,
            name: academicYear.name,
            training_type_id: academicYear.training_type_id,
            start_date: academicYear.start_date,
            end_date: academicYear.end_date,
            description: academicYear.description,
            is_active: academicYear.is_active,

        });


        // Set for update url
        setIsEdit(true);

        toggle();
    };

    //delete Serial movie
    const [deleteModal, setDeleteModal] = useState(false);

    const onClickDelete = (academicYear) => {
        setAcademicYear(academicYear);
        setDeleteModal(true);
    };

    const handleDeleteAcademicYear = () => {
        if (academicYear && academicYear.id) {
            //dispatch(onDeleteSerialeventCategory(serialeventCategory.id));
            dispatch(onDeleteAcademicYear(academicYear));
            setDeleteModal(false);
        }
    };

    const onClickNewAcademicYear = () => {
        setIsEdit(false);
        setAcademicYear(null);
        toggle();
        //setModal(true)
    };

    const columns = useMemo(
        () => [
            {
                header: 'ID',
                accessorKey: "id",
                enableColumnFilter: false,
                enableSorting: true,
                cell: (cellProps) => {
                    return <Link to="#" className="text-body fw-bold">{cellProps.row.original.id}</Link>
                }
            },
            {
                header: "Nom",
                accessorKey: "name",
                enableColumnFilter: false,
                enableSorting: true,
            },
            {
                header: "Type de formation",
                accessorKey: "training_type.name",
                enableColumnFilter: false,
                enableSorting: true,
            },
            {
                header: "Date début",
                accessorKey: "start_date",
                enableColumnFilter: false,
                enableSorting: true,
                cell: (cellProps) => {
                    const dateStr = cellProps.row.original.start_date;
                    return format(dateStr, "dd/MM/yyyy", { locale: fr }); 
                },
            },
            {
                header: "Date fin",
                accessorKey: "end_date",
                enableColumnFilter: false,
                enableSorting: true,
                cell: (cellProps) => {
                    const dateStr = cellProps.row.original.end_date;
                    return format(dateStr, "dd/MM/yyyy", { locale: fr }); 
                },
            },
            {
                header: "Active",
                accessorKey: "is_active",
                enableColumnFilter: false,
                enableSorting: true,
                cell: (cellProps) => {
                    const active = cellProps.row.original.is_active;
                    return (
                        <span className={`badge ${active ? "bg-success" : "bg-danger"}`}>
                            {active ? "Oui" : "Non"}
                        </span>
                    );
                },
            },
            
            
            
            
            {
                header: 'Action',
                enableColumnFilter: false,
                enableSorting: true,
                cell: (cellProps) => {
                    return (
                        <ul className="list-unstyled hstack gap-1 mb-0">
                            
                            <li>
                                <Link
                                    to="#"
                                    className="btn btn-sm btn-soft-info"
                                    onClick={() => {
                                        const jobData = cellProps.row.original;
                                        handleAcademicYearClick(jobData);
                                    }}
                                    id={`edittooltip-${cellProps.row.original.id}`}
                                >
                                    <i className="mdi mdi-pencil-outline" />
                                    <UncontrolledTooltip placement="top" target={`edittooltip-${cellProps.row.original.id}`} >
                                        Edit
                                    </UncontrolledTooltip>
                                </Link>
                            </li>

                            <li>
                                <Link
                                    to="#"
                                    className="btn btn-sm btn-soft-danger"
                                    onClick={() => {
                                        const jobData = cellProps.row.original;
                                        //console.log("ON DELETE: ", jobData);
                                        onClickDelete(jobData);
                                    }}
                                    id={`deletetooltip-${cellProps.row.original.id}`}
                                >
                                    <i className="mdi mdi-delete-outline" />
                                    <UncontrolledTooltip placement="top" target={`deletetooltip-${cellProps.row.original.id}`}>
                                        Delete
                                    </UncontrolledTooltip>
                                </Link>
                            </li>
                        </ul>
                    );
                }
            },
        ],
        []
    );

    return (
        <React.Fragment>
            <DeleteModal
                show={deleteModal}
                onDeleteClick={handleDeleteAcademicYear}
                onCloseClick={() => setDeleteModal(false)}
            />
            <div className="page-content">
                <div className="container-fluid">
                    <Breadcrumbs title="Années académiques" breadcrumbItem="Liste des années académiques" />
                    {
                        isLoading ? <Spinners setLoading={setLoading} />
                            :
                            <Row>
                                <Col lg="12">
                                    <Card>
                                        <CardBody className="border-bottom">
                                            <div className="d-flex align-items-center">
                                                <h5 className="mb-0 card-title flex-grow-1"></h5> 
                                                <div className="flex-shrink-0">
                                                    <Link to="#!" onClick={onClickNewAcademicYear} className="btn btn-primary me-1">Ajouter une année académique</Link>
                                                    
                                                </div>
                                            </div>
                                        </CardBody>
                                        <CardBody>
                                            <TableContainer
                                                columns={columns}
                                                data={academicYears || []}
                                                isCustomPageSize={true}
                                                isGlobalFilter={true}
                                                //isJobListGlobalFilter={false}
                                                isPagination={true}
                                                SearchPlaceholder="Rechercher ..."
                                                tableClass="align-middle table-nowrap dt-responsive nowrap w-100 table-check dataTable no-footer dtr-inline"
                                                theadClass="table-light"

                        
                                                
                                                //tableClass="align-middle table-nowrap dt-responsive nowrap w-100 table-check dataTable no-footer dtr-inline mt-4 border-top"
                                                pagination="pagination"
                                                paginationWrapper="dataTables_paginate paging_simple_numbers pagination-rounded"
                                            />
                                        </CardBody>
                                    </Card>
                                </Col>
                            </Row>
                    }
                    {/* Modal séparé */}
                    <AcademicYearModal
                        modal={modal}
                        toggle={toggle}
                        isEdit={isEdit}
                        academicYear={academicYear}
                        trainingTypes={trainingTypes}
                        onSubmit={(payload) => {
                        if (isEdit) {
                            dispatch(onUpdateAcademicYear(payload));
                        } else {
                            dispatch(onAddNewAcademicYear(payload));
                        }

                        // Force le rechargement de la liste pour actualiser les statuts "Active"
                        dispatch(onGetAcademicYears());


                        toggle(); // Fermeture automatique après succès
                        }}
                    />
                </div>
            </div>
            <ToastContainer />
        </React.Fragment>
    );
}


export default AcademicYearList;